<template>
	<div v-if="loaded">
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>Station Information</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* required</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>Station Name *</label>
							<md-input type="text" v-model="station.name"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>Station Description *</label>
							<md-input type="text" v-model="station.description"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<label>Station Location *</label>
						<Map v-if="loaded" :latitude="station.lat" :longitude="station.lng" style="height: 300px"
							@locationUpdated="locationUpdated">
						</Map>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>Summary</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">Station Name</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(station.name).length > 0">{{station.name}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Station Description</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(station.description).length > 0">{{station.description}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Station Latitude</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="station.lat != 0">{{station.lat}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Station Longtiude</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="station.lng != 0">{{station.lng}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateStation()">Update</md-button>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import { Settings } from 'luxon';
	import Map from 'vue-google-maps-location-selector';
	Settings.defaultLocale = 'km'
	export default {
		components: {
			datetime: Datetime,
			Map
		},
		created() {
			this.getStation();

		},
		data() {
			return {
				loaded: false,
				station: {
					name: "",
					description: "",
					lat: 0,
					lng: 0
				},
				isValid: false

			}
		},
		methods: {
			locationUpdated(latLng) {
				this.station.lat = latLng.lat;
    			this.station.lng = latLng.lng;
			},
			getStation(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/station/get/" + this.$route.params.hash_id).then(data => {
					this.station = data.body.data
					// console.log(data.body.data)
					this.loaded = true
				})
			},
			updateStation() {

				if (this.checkValidation()) {
					this.$http.post(this.config.api + "/admin/station/update", {
						station_hash_id: this.$route.params.hash_id,
						station: this.station
					}).then(res => {
						if (res.body.status == 'success') {
							this.tabName = 'first'
							this.$notification.notify({
								message: "បានកែប្រែដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.$router.push("/stations");
							// this.$router.push('/stations/detail/' + this.$route.params.hash_id);
						}
					})
				} else {
					this.$notification.notify({
						message: "Please fill in information",
						icon: 'error',
						type: 'danger'
					})
				}
			},
			checkValidation() {
				if (String(this.station.name).length > 0 && String(this.station.description).length > 0 &&
					String(this.station.lat).length > 0 && String(this.station.lng).length > 0) {
					return true;
				} else {
					return false;
				}
			}
		}
	}
</script>
<style>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50% !important;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Stations/Edit.vue